<template>
  <v-container class="py-6 px-4 profile-page-container">
    <!-- Profil kartasi -->
    <v-card class="rounded-xl pa-4 mb-4 card-background" dark>
      <v-row no-gutters>
        <v-col cols="3" class="d-flex justify-center align-center">
          <v-avatar size="60" color="cyan">
            <img :src="telegramUser.photo_url" alt="image">
          </v-avatar>
        </v-col>
        <v-col cols="9">
          <div class="text-subtitle-1 font-weight-bold">
            {{ telegramUser.first_name }} {{ telegramUser.last_name }}
          </div>
          <div class="text-caption d-flex align-center">
            <v-icon small class="mr-1">mdi-account</v-icon>
            ID: {{ telegramUser.id }}
          </div>
          <div class="text-caption d-flex align-center">
            <v-icon small class="mr-1">mdi-calendar</v-icon>
            Biz bilan {{ telegramUser.since }}
          </div>
        </v-col>
      </v-row>
    </v-card>

    <!-- Kodlar statistikasi -->
    <!-- <v-card class="rounded-xl py-6 mb-4 card-background" dark>
      <div class="text-center" @click="toMy()">
        <div class="text-h4 font-weight-bold">0</div>
        <div class="text-subtitle-2">Kodlar yuklangan</div>
      </div>
    </v-card> -->

    <!-- Sozlamalar -->
    <!-- <v-card class="rounded-xl pa-4 card-background" dark>
      <div class="d-flex align-center mb-2">
        <v-icon left class="mr-2">mdi-translate</v-icon>
        <span>Ilova tili</span>
      </div>

      <div class="d-flex">
        <v-btn
          class="mr-2"
          :class="language === 'RUS' ? 'white--text' : 'blue--text text--darken-2'"
          color="#ffffff15"
          depressed
          @click="language = 'RUS'"
        >
          РУС
        </v-btn>
        <v-btn
          :class="language === 'UZB' ? 'white--text' : 'blue--text text--darken-2'"
          color="#ffffff15"
          depressed
          @click="language = 'UZB'"
        >
          UZB
        </v-btn>
      </div>
    </v-card> -->
  </v-container>
</template>

<script>
import WebApp from "@twa-dev/sdk";
import axios from "axios";

export default {
  name: 'ProfilePage',
  data() {
    return {
      telegramUser: null,
      language: 'UZB',
      consoleError: null,
    };
  },
  computed: {
    // userInitial() {
    //   const fullName = this.telegramUser?.full_name?.trim();
    //   return fullName ? fullName.charAt(0).toUpperCase() : 'U';
    // },
  },
  methods:{
    toMy(){
      this.$router.push('/my-candidate');
    },
    initializeTelegramWebApp() {
      try {
        WebApp.ready();
        const userData = WebApp.initDataUnsafe.user || {};
        const initData = WebApp.initData;
        this.telegramUser = userData;
        axios
          .post(
            this.$store.state.backend_url + "api/tg-login",
            { initData }
          )
          .then(res => {
            this.consoleError = res.data;
          })
          .catch(err => {
            console.log(err);
          });
      } catch (error) {
        console.error("Telegram Web App init error:", error);
      }
    },
  },
  mounted() {
    this.initializeTelegramWebApp();
  },
};
</script>

<style scoped>
.profile-page-container {
  height: 100vh;
  overflow: hidden !important; /* scroll o'chiriladi */
  overscroll-behavior: none;   /* swipe o'chiriladi */
}

.v-card {
  backdrop-filter: blur(12px);
}
</style>
